export const definedRoutes = [
  '/',
  '/login',
  '/createAccount',
  '/requestResetPassword',
  '/reset-password',
  '/onboarding',
  '/dashboard',
  '/:providerId/:providerName/postsview',
  '/:providerId/:providerName/postsview/:postID',
  '/:providerId/:providerName/allComments',
  '/:providerId/:providerName/directMessages',
  '/:providerId/:providerName/directMessages/:pageConvoID',
  '/settings',
  '/global/settings',
  '/operations',
  '/:providerId/:providerName/adComments',
  '/:providerId/:providerName/settings',
];

export const pagesWithSidebar = [
  '/dashboard',
  '/:providerId/:providerName/postsview',
  '/:providerId/:providerName/postsview/:postID',
  '/:providerId/:providerName/allComments',
  '/:providerId/:providerName/directMessages',
  '/:providerId/:providerName/directMessages/:pageConvoID',
  '/settings',
  '/global/settings',
  '/:providerId/:providerName/analytics',
  '/:providerId/:providerName/adComments',
  '/:providerId/:providerName/settings',
];
